import React from 'react';
import { useReveal } from '../lib/useReveal';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/58ioQJx8j1dkfEGYpPb3CH/ChatGPT_Image_23_may_2026,_13_06_28.png';
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="pt-5 pb-6 md:pt-8 md:pb-10 px-5 sm:px-6 overflow-hidden relative bg-[#faf5fc]" data-id="element-193">
      <div ref={ref1} className={`reveal container mx-auto max-w-3xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-194">
        {/* Brand */}
        <p className="text-[#c9a14d] text-[10px] sm:text-xs font-bold tracking-[0.25em] uppercase mb-2" style={{
        fontFamily: "'Inter', sans-serif"
      }} data-id="element-195">
          ⭐ Academia Holística Argentina ⭐
        </p>

        {/* Title */}
        <h1 className="text-[#3d2a5f] font-bold leading-[1.05] mb-4 text-3xl sm:text-4xl md:text-5xl" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-196">
          <span className="block italic text-[#c9a14d]" data-id="element-197">MegaPack</span>
          <span className="block" data-id="element-198">Maestría Reiki</span>
        </h1>

        {/* Compact Hero Image */}
        <div className="block mx-auto w-full max-w-md sm:max-w-lg mb-5 relative" data-id="element-199">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_15px_40px_rgba(61,42,95,0.18)] border border-[#e8d5f0]" data-id="element-200">
            <img src={HERO_IMG} alt="MegaPack Maestría Reiki" className="w-full object-cover block" data-id="element-201" />
          </div>
        </div>

        {/* CTA — visible without scroll */}
        <div className="flex flex-col items-center gap-2 w-full max-w-md mx-auto" data-id="element-202">
          <a href="#pricing-offer" className="w-full block px-4 py-4 rounded-xl text-white font-bold text-sm sm:text-base tracking-wider uppercase transition-all shadow-[0_10px_30px_rgba(201,161,77,0.4)] hover:shadow-[0_15px_40px_rgba(201,161,77,0.5)] hover:-translate-y-1 bg-gradient-to-r from-[#c9a14d] to-[#b8945a] border border-[#c9a14d] text-center" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-203">
            → QUIERO MI MEGAPACK AHORA
          </a>
          <p className="text-[#6b5a85] text-xs font-medium flex items-center justify-center gap-2" data-id="element-204">
            <span data-id="element-205">🛡️ Garantía 7 días</span>
            <span data-id="element-206">•</span>
            <span data-id="element-207">🔒 Pago seguro</span>
          </p>
        </div>
      </div>
    </section>;
}